import { create } from "zustand";

export const useCenterData = create((set, get) => (
	{
		centerData: null,
		setCenterData: ({ centerData }) => set({ centerData }),
	}
))